import { ReactComponent as IosShare } from '../../../assets/iosShareIcon.svg'

export const IosShareIcon = () => (
    <IosShare height="40" width="40" />
)